import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appPreventNegativeInput]'
})
export class PreventNegativeInputDirective {
  @Input() inputType: 'integer' | 'float' = 'integer';
  @Input() maxFractionDigits: number = 2; // Default to 0 fractional digits (integer), float için 2 gibi verilebilir
  @Input() allowNegative: boolean = false; // Default: No negative values allowed
  @Input() min: number = 0; // Minimum değer (dinamik min kontrolü için eklendi)
  @Input() max: number | null = null;
  // keydown eventi ile sadece sayıları, nokta (.) ve virgül (,) karakterlerini kabul et, Backspace'e izin ver
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (this.isAllowedKey(event)) return;
    const inputValue = (event.target as HTMLInputElement).value;

    if (this.handleNegativeSign(event, inputValue)) return;
    if (this.inputType === 'integer') {
      this.handleIntegerKey(event);
      return;
    }
    if (this.inputType === 'float') {
      this.handleFloatKey(event, inputValue);
    }
  }

  private isAllowedKey(event: KeyboardEvent): boolean {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
    return allowedKeys.includes(event.key);
  }

  private handleNegativeSign(event: KeyboardEvent, value: string): boolean {
    if (this.allowNegative && event.key === '-') {
      if (value.length === 0) return true; // Allow only as first char
      event.preventDefault();
      return true;
    }
    return false;
  }

  private handleIntegerKey(event: KeyboardEvent): void {
    if (!/\d/.test(event.key)) event.preventDefault();
  }

  private handleFloatKey(event: KeyboardEvent, value: string): void {
    if (event.key === '.' || event.key === ',') {
      if (value === '' || value.includes('.') || value.includes(',')) {
        event.preventDefault();
        return;
      }
    }
    if (!/\d/.test(event.key) && event.key !== '.' && event.key !== ',') {
      event.preventDefault();
      return;
    }
    let separator: string | null = null;
    if (value.includes('.')) {
      separator = '.';
    } else if (value.includes(',')) {
      separator = ',';
    }

    if (!separator) return;

    const fractionPart = value.split(separator)[1];
    if (fractionPart && fractionPart.length >= this.maxFractionDigits && event.key !== 'Backspace') {
      event.preventDefault();
    }
  }


  // input event'i ile manuel yazma, kopyala-yapıştır, otomatik tamamlama gibi durumları kontrol et
  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;
    if (!value) return;

    const originalValue = value;

    value = this.normalizeValue(value);
    value = this.applyMinMax(value);

    if (value === originalValue) return;

    this.updateInputValue(inputElement, value);
  }
  private normalizeValue(value: string): string {
    value = value.replace(',', '.');

    if (!this.allowNegative && value.startsWith('-')) value = value.substring(1);

    if (this.inputType === 'integer') value = value.replaceAll(/\D/g, '');
    if (this.inputType === 'float') value = value.replaceAll(/[^0-9.]/g, '');

    if (this.inputType === 'float' && value.includes('.')) {
      const [intPart, fracPart] = value.split('.');
      if (fracPart.length > this.maxFractionDigits) {
        value = `${intPart}.${fracPart.substring(0, this.maxFractionDigits)}`;
      }
    }

    return value;
  }

  private applyMinMax(value: string): string {
    const numericValue = Number.parseFloat(value);
    if (!Number.isNaN(numericValue)) {
      if (numericValue < this.min) value = this.min.toString();
      if (this.max !== null && numericValue > this.max) value = this.max.toString();
    }
    return value;
  }

  private updateInputValue(input: HTMLInputElement, value: string): void {
    input.value = value;
    const setter = Object.getOwnPropertyDescriptor(globalThis.HTMLInputElement.prototype, 'value')?.set;
    setter?.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
